import { render, staticRenderFns } from "./ChatMessageActions.vue?vue&type=template&id=dcba6dd8&scoped=true"
import script from "./ChatMessageActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatMessageActions.vue?vue&type=style&index=0&id=dcba6dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcba6dd8",
  null
  
)

export default component.exports